import API_URLS from '../../constants/api-urls';
import { WISHLIST_GQL_SORTING_MAP } from '../../constants/wishlist-sorting';
import axios from '../../utils/axios';
import { searchStateToGqlFilters } from '../../utils/base-search/search-state-to-gql-filters';
import searchStateToGqlPagination from '../../utils/base-search/search-state-to-gql-pagination';
import { searchStateToGqlSorting } from '../../utils/base-search/search-state-to-gql-sorting';
import { WISHLIST_BASE_FILTERS } from './query-wishlist-materials.constants';

type QueryWishlistMaterialsOptions = { isAnonymousUser?: boolean; filter?: string };

export const queryWishlistMaterials = (
    search: SearchState,
    { isAnonymousUser = false, filter = '' }: QueryWishlistMaterialsOptions = {}
): Promise<{ total: number; wishlist: Material[] }> => {
    const url = isAnonymousUser ? API_URLS.ANONYMOUS_WISHLIST : API_URLS.WISHLIST;
    const filters = `${WISHLIST_BASE_FILTERS} ${filter}`;

    const schema = `
            {
                wishlist (
                    ${searchStateToGqlFilters(search, filters)}
                    ${searchStateToGqlPagination(search)}
                    ${searchStateToGqlSorting(search, WISHLIST_GQL_SORTING_MAP)}
                ) {
                    id
                    aclId
                    isFree
                    bundle
                    firstPreviewImage {
                        plain
                        watermarked
                    }
                    author {
                        id
                        slug
                        details {
                            publicName
                        }
                    }
                    materialTopCategories {
                        id
                        title
                    }
                    materialFiles {
                        type
                    }
                    materialClassGrades {
                        id
                        title
                    }
                    interactiveId
                    sale {
                        expireAt
                        original_price
                        sale_price
                        startAt
                    }
                    fileTypes
                    isBundleInteractive
                    isStandaloneInteractive
                    bundleMaterialsPrice
                    bundleListTotal
                    distributionType
                    bestInCategories {
                        id
                    }
                    isHighQuality
                    description
                    slug
                    totalPages
                    prices
                    price
                    title
                    url
                    world
                    averageRating
                    totalFeedbacks
                    _total
                }
            }
        `;

    return new Promise((resolve) => {
        axios.post(`${url}/query`, { query: schema }).then(
            (response) => {
                const { wishlist } = response.data;
                let total = 0;

                if (wishlist[0] && wishlist[0].id) {
                    total = wishlist[0]._total;
                }

                resolve({
                    total,
                    wishlist: total ? wishlist : []
                });
            },
            () => {
                resolve({
                    total: 0,
                    wishlist: []
                });
            }
        );
    });
};
